import React, { FC, useEffect, useState } from 'react';
import ProductImageSelect from '../../../../common/Form/FormFields/ProductImageSelect/ProductImageSelect';
import { useFormContext } from 'react-hook-form';
import useCartModelDisplay from '../../../../../hooks/useCartModelDisplay';
import Product from '../../../../../@types/Product';
import { ChassisSeriesTypes } from '../../../../../@types/ChassisType';

interface CartProductWheelsProps {
  retailConfigurator: boolean,
  hideAllPrices: boolean
}

const CartProductWheels: FC<CartProductWheelsProps> = ({ retailConfigurator, hideAllPrices }) => {
  const [wheelOptions12, setWheelOptions12] = useState<Product[]>();
  const [wheelOptions14, setWheelOptions14] = useState<Product[]>();
  const [wheelOptions15, setWheelOptions15] = useState<Product[]>();

  const { watch, setValue, getValues } = useFormContext();
  const { chassisType, setWheel, setWheelSize } = useCartModelDisplay();

  const currentCart = getValues();
  const editable = currentCart?.isFromInventory
    ? (currentCart?.wheelEditable ?? false)
    : true;

  const wheel: Product | undefined = watch('wheel');
  const liftKit: Product | undefined = watch('liftKit');

  useEffect(() => {
    setWheelSize(typeof wheel?.refId === 'number' ? wheel.refId : 12);
    setWheel(wheel);
    setValue('wheelSize', wheel?.refId);
    if (wheel?.linkedProducts?.length) {
      const linkedProduct = wheel?.linkedProducts[0];
      setValue('lugNut', linkedProduct);
    }

    // Select tire options
    // This will be removed when more tire options become available
    const tires = [...chassisType?.tireOptions ?? []];
    const tiresLifted = [...chassisType?.tireOptionsLifted ?? []];

    const tireProductOptions = liftKit?.sku === 'NL'
      ? tires.filter((product) => product.refId === wheel?.refId)
      : tiresLifted.filter((product) => product.refId === wheel?.refId);

    // Check the amount of tire options to see if we should default select
    // when only one option is present for the user
    if (tireProductOptions
      && tireProductOptions.length < 2
      && tireProductOptions.length) {
      setValue('tire', tireProductOptions[0]);
    }

  }, [
    wheel,
    chassisType,
    liftKit,
    wheelOptions12,
    wheelOptions14,
    wheelOptions15,
    setWheel
  ]);

  useEffect(() => {
    const wheelOptions12: Product[] | [] = chassisType?.wheelOptions.filter((product) => product.refId === 12) ?? [];
    const wheelOptions12Lifted: Product[] | [] = chassisType?.wheelOptionsLifted.filter((product) => product.refId === 12) ?? [];
    const wheelOptions14: Product[] | [] = chassisType?.wheelOptions.filter((product) => product.refId === 14) ?? [];
    const wheelOptions14Lifted: Product[] | [] = chassisType?.wheelOptionsLifted.filter((product) => product.refId === 14) ?? [];
    const wheelOptions15: Product[] | [] = chassisType?.wheelOptionsLifted.filter((product) => product.refId === 15) ?? [];

    /*
      Detect which wheel was selected prior to lift kit change
      assign the correct wheel match between lifted and non-lifted
      when applicable or else default to a 14" wheel
    */

    const currentSelectedWheel: Product | undefined = getValues('wheel');

    setWheelOptions12(
      liftKit?.sku === 'L'
        ? wheelOptions12Lifted
        : wheelOptions12);
    setWheelOptions14(
      liftKit?.sku === 'L'
        ? wheelOptions14Lifted
        : wheelOptions14);
    setWheelOptions15(
      liftKit?.sku === 'L'
        ? wheelOptions15
        : []);


    const wheelToReselect: Product | undefined =
      liftKit?.sku === 'L'
        ? [
          ...wheelOptions12Lifted ?? [],
          ...wheelOptions14Lifted ?? [],
          ...wheelOptions15 ?? []]
          .find((product) => product.sku === currentSelectedWheel?.sku)
        : [
          ...wheelOptions12 ?? [],
          ...wheelOptions14 ?? []
        ].find((product) => product.sku === currentSelectedWheel?.sku)

    const wheelToDefaultTo: Product | undefined =
      chassisType?.series === ChassisSeriesTypes.ESeries
        ? liftKit?.sku === 'L' ? wheelOptions12Lifted[0] : wheelOptions12[0]
        : liftKit?.sku === 'L' ? wheelOptions14Lifted[0] : wheelOptions14[0]

    if (wheelToReselect || wheelToDefaultTo) {
      setValue('wheel', wheelToReselect ?? wheelToDefaultTo);
      setWheel(wheelToReselect ?? wheelToDefaultTo);
    }

  }, [
    liftKit,
    chassisType,
    getValues,
    setValue
  ]);

  return (
    <>
      <ProductImageSelect
        name="wheel"
        label="Wheels"
        disableImageZoom={true}
        displayLabel={false}
        displayPrice={!hideAllPrices}
        productAlignment='left'
        displayRetailPrice={retailConfigurator}
        products={wheelOptions12 ?? []}
        disabled={!editable} />
      <ProductImageSelect
        name="wheel"
        label="Wheels"
        disableImageZoom={true}
        displayLabel={false}
        displayPrice={!hideAllPrices}
        productAlignment='left'
        displayRetailPrice={retailConfigurator}
        products={wheelOptions14 ?? []}
        disabled={!editable} />
      <ProductImageSelect
        name="wheel"
        label="Wheels"
        disableImageZoom={true}
        displayLabel={false}
        displayPrice={!hideAllPrices}
        productAlignment='left'
        displayRetailPrice={retailConfigurator}
        products={wheelOptions15 ?? []}
        disabled={!editable} />
    </>

  );
}

export default CartProductWheels;
